import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { CreateButton } from "@/components/admin/create-button";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";
import { FilterButton } from "@/components/admin/filter-form";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { useTranslate } from "ra-core";
import { TopToolbar } from "../../layout/TopToolbar";
import { transactionDirectionChoices } from "../shared/transactionModel";
import { getCategoryIcon } from "./CategoryIconPicker";
import type { TransactionCategory } from "../../types";

const categoryFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput
    source="direction"
    choices={transactionDirectionChoices}
    label="resources.transaction_categories.fields.direction"
  />,
];

export const CategoryList = () => (
  <List
    sort={{ field: "name", order: "ASC" }}
    filters={categoryFilters}
    filter={{ "archived_at@is": null }}
    actions={<CategoryActions />}
    pagination={<ListPagination rowsPerPageOptions={[25, 50, 100]} />}
  >
    <div className="mb-3 flex flex-wrap gap-2">
      <ToggleFilterButton
        label="resources.transactions.directions.income"
        value={{ direction: "income" }}
        className="w-auto"
      />
      <ToggleFilterButton
        label="resources.transactions.directions.expense"
        value={{ direction: "expense" }}
        className="w-auto"
      />
    </div>
    <DataTable<TransactionCategory> rowClick="edit">
      <DataTable.Col source="name" />
      <DataTable.Col
        source="direction"
        render={(r) => <DirectionCell direction={r.direction} />}
      />
      <DataTable.Col
        source="icon"
        render={(r) => {
          const Icon = getCategoryIcon(r.icon);
          return Icon ? (
            <div className="flex items-center gap-2 text-sm">
              <Icon className="h-4 w-4" />
              <span className="text-muted-foreground">{r.icon}</span>
            </div>
          ) : (
            r.icon ?? null
          );
        }}
      />
      <DataTable.Col
        source="color"
        render={(r) =>
          r.color ? (
            <span
              className="inline-block h-4 w-4 rounded-full border align-middle"
              style={{ backgroundColor: r.color }}
            />
          ) : null
        }
      />
    </DataTable>
  </List>
);

const DirectionCell = ({ direction }: { direction: string }) => {
  const translate = useTranslate();
  return <>{translate(`resources.transactions.directions.${direction}`, { _: direction })}</>;
};

const CategoryActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton label="resources.transaction_categories.action.new" />
  </TopToolbar>
);
